const title = {
    name: "",
    imageUrl: "",
    year: 1970,
    genres: [],
    keywords: [],
    type: "",
    episodes: {
        total: 0,
        seasons: 0
    },
    rating: {
        avgRating: 0,
        voteCount: "",
        popularity: {
            current: 0,
            changeDirection: "",
            difference: 0
        }
    },
    plot: "",
    writers: [{ id:"", name:"" }],
    directors: [{ id:"", name:"" }],
    creators: [{ id:"", name:"" }],
    stars: [{ id:"", name:"" }],
    runtime: "",
    trailerUrl: ""
}

export default title;